import moment from "moment";

const EDITABLE_FIELDS = ['price', 'remainingBalance', 'description', 'created', 'concludedAt', 'alertUsageDate', 'expireDate', 'expiredAt', 'deleted'];

const DATE_FIELDS = ['created', 'concludedAt', 'expireDate', 'expiredAt', 'alertUsageDate'];

const NUMBER_FIELDS = ['price', 'remainingBalance'];

const DATE_FORMAT = "YYYY-MM-DDTHH:mm";

const DATE_TIME_INPUT_LENGTH = DATE_FORMAT.length;

const isEmpty = (value) => value === undefined || value === null || value === '';

export const toDateTimeInput = (value) => (value ? String(value).substring(0, DATE_TIME_INPUT_LENGTH) : value);

const asComparableDate = (value) => {
    if (typeof value === 'string')
        return toDateTimeInput(value);

    const parsed = moment(value);

    return parsed.isValid() ? parsed.format(DATE_FORMAT) : undefined;
};

const asComparableNumber = (value) => {
    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : undefined;
};

const isConfidentlyUnchanged = (field, current, read) => {
    if (isEmpty(current) && isEmpty(read))
        return true;

    if (isEmpty(current) || isEmpty(read))
        return false;

    if (DATE_FIELDS.includes(field)) {
        const currentDate = asComparableDate(current);

        return currentDate !== undefined && currentDate === asComparableDate(read);
    }

    if (NUMBER_FIELDS.includes(field)) {
        const currentNumber = asComparableNumber(current);

        return currentNumber !== undefined && currentNumber === asComparableNumber(read);
    }

    return String(current) === String(read);
};

const formatEditableDates = (data) => ({
    ...data,
    created: data.created && (moment(data.created).format(DATE_FORMAT)),
    expireDate: data.expireDate && (moment(data.expireDate).format(DATE_FORMAT)),
    expiredAt: data.expiredAt && (moment(data.expiredAt).format(DATE_FORMAT)),
    concludedAt: data.concludedAt && (moment(data.concludedAt).format(DATE_FORMAT))
});

export const buildEditPayload = (data, readSnapshot) => {
    const formatted = formatEditableDates(data);

    if (!readSnapshot)
        return formatted;

    const changed = EDITABLE_FIELDS
        .filter(field => field in formatted)
        .filter(field => !isConfidentlyUnchanged(field, formatted[field], readSnapshot[field]))
        .reduce((payload, field) => ({ ...payload, [field]: formatted[field] }), {});

    return isEmpty(readSnapshot.remainingBalance)
        ? changed
        : { ...changed, remainingBalanceAtRead: readSnapshot.remainingBalance };
};
